import Ajax from "../utils/ajax";

export default {
  namespaced: true,
  state: {
    request: {
      skip: 1,
      criterio: "",
      cantidad: 10,
    },
    response: {
      listEmpleados: [],
      cantidad: 0,
    },
    roles:[]
  },

  mutations: {
    SET_RESPONSE_USERS(state, payload) {
      state.response = payload;
    },
    SET_SKIP(state, payload) {
      state.request.skip = payload;
    },
    SET_CRITERIO(state, payload) {
      state.request.criterio = payload;
    },

    GET_ROLES(state, payload){
      state.roles = payload; 
    }
  },

  actions: {
    async getUsers({ commit }, {data}) {
      const resp = await Ajax.get("/api/v1/Employee/list", { params: data });
      commit("SET_RESPONSE_USERS", resp.data);
    },

    async changeStatus({ commit }, {data}) {
      try {
        const resp = await Ajax.put("/api/v1/Employee/locked", data);
        return Promise.resolve(resp.data);
      } catch (e) {
        return Promise.reject(e);
      }
    },

    async createUser({commit}, {data}){
      try {
    
        const resp = await Ajax.post("/api/v1/Auth/createUser", data); 
        return Promise.resolve(resp.data)
      } catch (e) {
        return Promise.reject(e.response.data)
      }
    },

    async getRoles({commit}){
      const resp = await Ajax.get("/api/v1/Auth/role"); 
      commit("GET_ROLES", resp.data)
    }
  },
};
